import Vue from 'vue'
import Product from '../models/Shop/Product'

export const state = () => ({
  currency: {
    curr: 'EUR',
    symbol: '€',
    ratio: 1
  },
  search_products: [],
  activeProduct: null
})

// getters
export const getters = {
  getCurrency: (state) => {
    return state.currency
  }
}
// mutations
export const mutations = {
  setCurrency: (state, payload) => {
    state.currency = payload
  },
  setSearchProducts: (state, payload) => {
    state.search_products = payload
  }
}
// actions
export const actions = {
  async fetchProducts ({}, payload) {
    try {
      const products = Product.include('media', 'category', 'prices')
      if (payload) {
        if (payload.category_id) {
          products.where('category_id', payload.category_id)
        }
        if (payload.price_between) {
          products.where('price_between', payload.price_between)
        }
        if (payload.sort) {
          products.orderBy(payload.sort)
        }
        if (payload.page) {
          products.page(parseInt(payload.page))
        }
      }
      return await products.get()
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchProduct ({ commit }, product_slug) {
    const result = await Product
      .include('unit', 'parameters', 'parameters.parameter', 'category', 'media', 'reviews', 'prices')
      .find(product_slug)
    return result.data
  },
  async fetchFrontPageCollections ({ commit }) {
    try {
      const result = await this.$axios.get('/products/front-page', {})
      return result.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  changeCurrency: ({ commit }, payload) => {
    commit('changeCurrency', payload)
  },
  async searchProducts ({ commit }, payload) {
    if (payload.length === 0) {
      commit('setSearchProducts', [])
    } else {
      try {
        const products = await Product.where('search', payload).include('category', 'prices').get()
        commit('setSearchProducts', products.data)
      } catch (err) {
        if (process.client) {
          Vue.notify({
            group: 'general',
            type: 'error',
            text: this.app.i18n.t('not_found')
          })
        }
      }
    }
  },
  async fetchFeaturedProducts ({ commit }) {
    try {
      const result = await Product.custom('products/featured').include('category', 'media', 'prices').get()
      return result.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async writeReview ({ commit }, payload) {
    try {
      const result = await this.$axios.post('/products/' + payload.product_slug + '/review', payload)
      return result
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('errors.failed_write_review')
        })
      }
    }
  }
}
